import { Type } from '@angular/core';
import { defer, Observable } from 'rxjs';

import { PageType } from '@ppg/core/enums';

export const PAGE_COMPONENT_IMPORT_MAP: { [key in PageType]: Observable<Type<unknown>> } = {
  [PageType.PAGE_ARTICLE]: defer(() => import('@ppg/features/article').then((component) => component.ArticleComponent)),
  [PageType.PAGE_ARTICLE_LIST]: defer(() =>
    import('@ppg/features/article-list').then((component) => component.ArticleListComponent),
  ),
  [PageType.PAGE_CATEGORY]: defer(() =>
    import('@ppg/features/category').then((component) => component.CategoryComponent),
  ),
  [PageType.PAGE_GENERAL]: defer(() => import('@ppg/features/general').then((component) => component.GeneralComponent)),
  [PageType.PAGE_GLOBAL_HOME]: defer(() =>
    import('@ppg/features/global-home').then((component) => component.GlobalHomeComponent),
  ),
  [PageType.PAGE_HUB]: defer(() => import('@ppg/features/hub').then((component) => component.HubComponent)),
  [PageType.PAGE_PRODUCT_LINE]: defer(() =>
    import('@ppg/features/product-line').then((component) => component.ProductLineComponent),
  ),
};
